<template>
    
 <v-card v-if="discountlist.length>0" flat color="transparent" :class="{'mx-2' : showCard}">                        
   <v-card-title v-if="showHeader" style="display:block;word-break: normal">Aanbiedingen</v-card-title>
        <v-card-subtitle v-if="showHeader && !showList && !showAll" style="display:block;word-break: normal">{{this.$moment().format('dddd DD MMMM YYYY')}}</v-card-subtitle>
        <v-divider v-if="!showCard && (!showList || $vuetify.breakpoint.mobile)"></v-divider>
        
          <template v-for="day in days">

             <v-card-subtitle class="primary--text justify-center" v-if="showList && discountlist.filter(d=>d.day==day).length>0 && day==-1" :key="'group' + day">Hele week</v-card-subtitle>
             <v-card-subtitle class="primary--text justify-center" v-else-if="showList && discountlist.filter(d=>d.day==day).length>0" :key="'group' + day" v-text="$moment.weekdays(true)[day].capitalize()"></v-card-subtitle>
            <v-list class="py-0" :outlined="showCard" :key="'L'+day" v-if="discountlist.filter(d=>d.day==day).length>0">
              <template v-for="(item,j) in discountlist.filter(d=>d.day==day)">
            
              <v-list-item :key="'item' + day + j" @click="select(item)">
                    <v-list-item-icon>
                      <v-icon v-if="item.deliver==true">mdi-truck-delivery-outline</v-icon>
                      <v-icon v-else-if="item.deliver==false">mdi-store</v-icon>
                      <v-icon v-else>euro</v-icon>
                      
                    </v-list-item-icon>
                  <v-list-item-content>
                  <v-list-item-title>{{item.name}}</v-list-item-title>
                  <v-list-item-subtitle v-html="item.description"></v-list-item-subtitle>
                  
                  </v-list-item-content>
                  <v-list-item-action v-if="item.quantity">{{item.pay}}/{{item.quantity}}</v-list-item-action>
                  <v-list-item-action v-else-if="item.percent">{{item.percent}}%</v-list-item-action>
                  <v-list-item-action v-else-if="item.price">{{item.price | toCurrency}}</v-list-item-action>
                  
              </v-list-item>
              <v-divider :key="'dd' + day + j" v-if="j<discountlist.filter(d=>d.day==day).length-1 && !borderLess"></v-divider>
              </template>
            </v-list>
          </template>
        
    
 </v-card>

</template>
<script>

export default {
   props: {
    value: {
      type: Array,
      default: function () {
        return []
      },
     },
     showAll: {
         type: Boolean,
         default: function (){
             return false
         }
     },
     showList: {
         type: Boolean,
         default: function (){
             return false
         }
     },
     showHeader: {
         type: Boolean,
         default: function (){
             return false
         }
     },
     deliver: {
         type: Boolean,
         default: function (){
             return false
         }
     },
     edit: {
         type: Boolean,
         default: function (){
             return false
         }
     },
      showCard: {
         type: Boolean,
         default: function (){
             return false
         }
     },
     borderLess: {
         type: Boolean,
         default: function (){
             return false
         }
     },
   },
  data: () => ({
    days: [-1.0,1,2,3,4,5,6],
  }),
  computed: {
    daylist (){
      let arr = this.$moment.weekdays().map((text,value)=>{
        return {text,value}
      })
      arr.unshift({text: 'Hele week', value:-1})
      return arr
    },
   
   
    discountlist(){
      var d = new Date();
      var n = d.getDay();
      
      if (this.showAll) return this.value.sort(aSort)
      return this.value.filter(d=>
        (d.deliver == this.deliver 
        || (!d.deliver && d.deliver!=false))
        && this.showAll || this.showList || (d.day == n || d.day==-1)).sort(aSort)
      }
   },
  mounted () {
    
  
  },
  watch: {

   
  },
  methods: {
   
  }
}

function aSort(a, b) {
  let dA = a.day
  let dB = b.day
  
  if (dA < dB) return -1;
  if (dB < dA) return 1;

  return 0;
}
function compare( a, b ) {
  if ( a.name < b.name ){
    return -1;
  }
  if ( a.name > b.name ){
    return 1;
  }
  return 0;
}
</script>
